var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#251D97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9027 18.435L29.3482 9.78027H27.5838L21.119 17.2951L15.9555 9.78027H10L17.8082 21.144L10 30.2198H11.7644L18.5915 22.2839L24.0445 30.2198H30L21.9023 18.435H21.9027ZM19.4861 21.2441L18.695 20.1125L12.4002 11.1085H15.1102L20.1902 18.375L20.9813 19.5066L27.5847 28.9519H24.8746L19.4861 21.2445V21.2441Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7dd7e7878955e2adc80ab45bd88ac469.svg";
export { ForwardRef as ReactComponent };